  let questionsq = document.querySelectorAll(".questionsq");
  questionsq.forEach(questionsq => {
    questionsq.addEventListener("click", event => {
      const active = document.querySelector(".questionsq.active");
      if (active && active !== questionsq) {
        active.classList.toggle("active");
        active.nextElementSibling.style.maxHeight = 0;
      }
      questionsq.classList.toggle("active");
      const answersq = questionsq.nextElementSibling;
      if (questionsq.classList.contains("active")) {
        answersq.style.maxHeight = answersq.scrollHeight + "px";
      } else {
        answersq.style.maxHeight = 0;
      }
    })
  })